import {Component, Input, Output, HostBinding, HostListener, ElementRef, EventEmitter} from '@angular/core';

let Ps = require('perfect-scrollbar');
let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:ModalCmp'));

// TODO: Is it possible to have the ngIf and also at the same time delay the component destruct enough time to fade out?
@Component({
    selector: 'modal-cmp',
    template: require('./modal.cmp.html'),
    styles: [String(require('./modal.cmp.scss'))],
    host: { class: 'modal' }
})
export class ModalCmp {

    @HostBinding('class.visible') modalElemIsVisible: boolean = false;
    @HostBinding('class.rendered') modalElemIsRendered: boolean = false;

    @Input() modalIsVisible;
    @Output() modalClosed = new EventEmitter();

    @HostListener('window:resize', ['$event']) onResize(event) {
        this._modalElement !== null && Ps.update( this._modalElement ); // Update navigation custom scroll
    }

    private _modalElement = null;

    
    constructor (
        private _elementRef: ElementRef,
    ) {
        // 'Construct modal' );

        this._modalElement = _elementRef.nativeElement;
    }

    
    ngOnInit() {
        // 'Initialise modal' );
    }

    
    ngOnChanges (changes) {
        // 'Modal visibility change detected:', [changes] );

        // Open or close modal following state store signal
        if (changes.modalIsVisible.currentValue === true) {
            this._fadeInModal();
        } else {
            this._fadeOutModal();
        }
    }

    
    ngOnDestroy() {
        // 'Destroy modal' );
        Ps.destroy( this._modalElement );
    }

    
    private _openModal () {
        // 'Open modal' );
        var self = this;

        // Setup navigation custom scroll
        Ps.initialize( self._modalElement, {
            minScrollbarLength: 30
        });
    }

    
    private _closeModal () {
        // 'Close modal' );
        this._fadeOutModal();
    }

    
    private _fadeInModal () {
        debugOff( 'Fade in modal' );
        var self = this;
        this.modalElemIsRendered = true;
        setTimeout( () => self.modalElemIsVisible = true, 0 );
    }

    
    private _fadeOutModal () {
        debugOff( 'Fade out modal' );
        var self = this;
        this.modalElemIsVisible = false;
        setTimeout( () => {
            self.modalElemIsRendered = false;
        }, 300);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/shared/components/ui-elements/modal.cmp.ts